import { useEffect } from "react";
import { create } from "zustand";

const MOBILE_BREAKPOINT = 640;

export const isMobileWidth = (width: number) => width <= MOBILE_BREAKPOINT;

export const getInitialIsMobile = (win: Window | undefined) => {
	if (!win) {
		return false;
	}

	return isMobileWidth(win.innerWidth);
};

type ViewportState = {
	isMobile: boolean;
	setIsMobile: (isMobile: boolean) => void;
};

export const useViewportStore = create<ViewportState>((set) => ({
	isMobile: getInitialIsMobile(typeof window === "undefined" ? undefined : window),
	setIsMobile: (isMobile) => set({ isMobile }),
}));

export const useViewportResize = () => {
	const setIsMobile = useViewportStore((s) => s.setIsMobile);

	useEffect(() => {
		const handleResize = () => setIsMobile(isMobileWidth(window.innerWidth));
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, [setIsMobile]);
};
